import { ORDER_TIME_OPTIONS } from '../../../../../modals/order-method/useOrderTimeOptions';
import { DropoffAction, ORDER_METHODS, RoomServiceLocationType } from '../../../../../services/exports/Constants';

export default {
  sections: {
    order_method: {
      titles: {
        [ORDER_METHODS.PICKUP]: 'Afhentning',
        [ORDER_METHODS.DELIVERY]: 'Levering',
        [ORDER_METHODS.ROOM_SERVICE]: {
          [RoomServiceLocationType.RoomService]: 'Roomservice',
          [RoomServiceLocationType.TableService]: 'Bordservice',
        },
      },
    },
    delivery_info: {
      title: 'Leveringsoplysninger',
      on_arrival: 'Ved ankomst:',
    },
    customer_info: {
      title: 'Kontakt',
    },
    payment: {
      title: 'Betaling',
    },
    request_invoice: {
      title: 'Anmod om faktura',
      form: {
        is_receipt_required: {
          label: 'Anmod om faktura via e-mail',
        },
      },
    },
    location: {
      title: 'Butikkens adresse',
      [ORDER_METHODS.DELIVERY]: {
        title: 'Leveringsadresse',
      },
      [ORDER_METHODS.ROOM_SERVICE]: {
        title: 'Adresse på stedet',
      },
      [ORDER_METHODS.PICKUP]: {
        title: 'Afhentningsadresse',
      },
    },
    method: {
      title: 'Metode',
      [ORDER_METHODS.DELIVERY]: {
        title: 'Levering',
      },
      [ORDER_METHODS.ROOM_SERVICE]: {
        title: 'På stedet',
      },
      [ORDER_METHODS.PICKUP]: {
        title: 'Afhentning',
      },
    },
    time: {
      title: 'Tidspunkt',
      method: {
        [ORDER_TIME_OPTIONS.asap]: {
          title: 'Standard {{time}} min., i dag',
        },
        [ORDER_TIME_OPTIONS.scheduled]: {
          title: 'Planlæg til senere',
        },
      },
    },
  },
  [RoomServiceLocationType.RoomService]: {
    details_label: 'Værelsesnummer',
  },
  [RoomServiceLocationType.TableService]: {
    details_label: 'Bordnummer',
  },
  form: {
    dropoff_action: {
      options: {
        [DropoffAction.RingDoorBell]: 'Ring på dørklokken',
        [DropoffAction.Sms]: 'Kontakt mig via SMS ved ankomst',
      },
    },
    doorbell_name: {
      placeholder: 'Navn på dørklokke (valgfrit)',
    },
    company_name: {
      placeholder: 'Firmanavn (valgfrit)',
    },
    customer_note: {
      placeholder: 'Har du en bemærkning til restauranten?',
    },
  },
  buttons: {
    change: 'Skift',
    edit: 'Rediger',
    done: 'Færdig',
    add_delivery_note: '+ Tilføj leveringsoplysninger',
    add_order_note: '+ Tilføj ordrebemærkning',
  },
  summary: {
    doorbell: 'Dørklokke',
    company: 'Firma',
    note: 'Ordrebemærkning',
  },
};
